
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { WorkshopService } from '../../../../../services/table-management/workshop.service';
import { WorkshopFormComponent } from '../workshop-form/workshop-form.component';
@Component({
  selector: 'app-workshop-list',
  templateUrl: './workshop-list.component.html',
  styleUrls: ['./workshop-list.component.css'],
  providers:[WorkshopService],
  standalone: false,
})
export class WorkshopListComponent extends EntityListComponent<Rest.InvWorkshop> implements OnInit {

  @ViewChild(WorkshopFormComponent, { static: true })
      workshopForm: WorkshopFormComponent;
    
      title: string = this.translateService.instant('tableManagement.sinister.workshop.title');
      disableSave: boolean;
      EnabledFilter: SelectItem[];

      isCreateGranted: boolean;
      isDisabledGranted: boolean;
    
      constructor(
        private workshopService: WorkshopService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService,
      ) {
        super(
          workshopService,
          confirmationService,
          notificationsService,
          i18n,
          authenticationService,
          loadingService,
          userTime,
          excelService
        );
        this.workshopService = workshopService;
      }
    
      ngOnInit() {
        super.ngOnInit();
        this.form = this.workshopForm;
        this.setPermissions();
      }
      beforeLoad() {
        
        this.paginationRequest.sortAsc= false;
        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
          this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
      }
    
      afterLoad() {
        
      }
      excelColumns = {};
      exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.sinister.workshop.title');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
      }
      setExcelColumns() {
        const name = (entity: any) => entity.name ?? ''
        const direction = (entity: any) => entity.direction ?? ''
        const phoneNumber = (entity: any) => entity.phoneNumber ?? ''
        const population = (entity: any) => entity.population ?? ''
        const province = (entity: any) => entity.province ?? ''
        const cp = (entity: any) => entity.cp ?? ''
        const contactPerson = (entity: any) => entity.contactPerson ?? ''
        const disabled = (entity: any) => !entity.disabled
        this.excelColumns = {
          [this.translateService.instant('general.name')]: { bindField: name },
          [this.translateService.instant('tableManagement.sinister.workshop.direction')]: { bindField: direction },
          [this.translateService.instant('tableManagement.sinister.workshop.phoneNumber')]: { bindField: phoneNumber },
          [this.translateService.instant('tableManagement.sinister.workshop.population')]: { bindField: population },
          [this.translateService.instant('tableManagement.sinister.workshop.province')]: { bindField: province },
          [this.translateService.instant('tableManagement.sinister.workshop.cp')]: { bindField: cp },
          [this.translateService.instant('tableManagement.sinister.workshop.contactPerson')]: { bindField: contactPerson },
          [this.translateService.instant('general.active')]: { bindField: disabled },
        }
      }

      setPermissions() {
		    const user = this.authenticationService.user;
		    this.isCreateGranted = this.authenticationService.isRoleGranted('INV_WORKSHOP_CREATE', user);
		    this.isDisabledGranted = this.authenticationService.isRoleGranted('INV_WORKSHOP_DISABLE', user);

	  }

}

